import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _disableRequest = {};
var _disableResponse = {};
var _enableRequest = {};
var _enableResponse = {};
var _getStudioWorkspaceRequest = {};
var _getStudioWorkspaceResponse = {};
function resolveWixStudioWorkspaceV1StudioWorkspaceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/studio-workspace',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/studio-workspace',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/studio-workspace-api',
                destPath: '',
            },
            {
                srcPath: '/_api/studio-workspace',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Enables studio-workspace to non-studio workspaces */
export function enable(payload) {
    var _a = serializer(_enableRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_enableResponse, {}).fromJSON;
    function __enable(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.studio.v1.workspace',
            method: 'POST',
            methodFqn: 'wix.studio.workspace.v1.StudioWorkspace.Enable',
            url: resolveWixStudioWorkspaceV1StudioWorkspaceUrl({
                protoPath: '/v1/enable',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __enable.fromReq = fromReq;
    __enable.__isAmbassador = true;
    return __enable;
}
/** Disables studio-workspace to if the user requires to opt-out */
export function disable(payload) {
    var _a = serializer(_disableRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_disableResponse, {}).fromJSON;
    function __disable(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.studio.v1.workspace',
            method: 'POST',
            methodFqn: 'wix.studio.workspace.v1.StudioWorkspace.Disable',
            url: resolveWixStudioWorkspaceV1StudioWorkspaceUrl({
                protoPath: '/v1/disable',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __disable.fromReq = fromReq;
    __disable.__isAmbassador = true;
    return __disable;
}
/** Checks if the workspace is a studio workspace */
export function getStudioWorkspace(payload) {
    var _a = serializer(_getStudioWorkspaceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getStudioWorkspaceResponse, {}).fromJSON;
    function __getStudioWorkspace(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.studio.v1.workspace',
            method: 'GET',
            methodFqn: 'wix.studio.workspace.v1.StudioWorkspace.GetStudioWorkspace',
            url: resolveWixStudioWorkspaceV1StudioWorkspaceUrl({
                protoPath: '/v1/workspace',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getStudioWorkspace.fromReq = fromReq;
    __getStudioWorkspace.__isAmbassador = true;
    return __getStudioWorkspace;
}
//# sourceMappingURL=http.impl.js.map